import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaA_Van_Left: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="103"
      height="115"
      viewBox="0 0 103 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_a_van_left"
          x="0"
          y="0"
          width="103"
          height="115"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_a_van_left)">
        <path
          d="M59.5469 2.52734C61.9513 5.02014 64.0793 7.17331 64.7822 7.84375V7.84473L64.792 7.85449L64.8018 7.86328C65.2074 8.24855 66.2789 9.35087 67.0967 9.97168C67.5746 10.3345 68.4764 10.9555 69.7041 11.2471C71.1544 11.5913 72.7429 11.3964 74.1445 10.5293L74.1631 10.5205L74.2061 10.4932C74.9807 10.0011 75.76 9.22161 76.1768 8.79785C76.7414 8.22377 77.3745 7.53198 77.9736 6.82812C78.0594 6.72741 78.1441 6.62353 78.2305 6.51953L78.3174 6.85352L78.3193 6.85938C80.3122 14.8032 83.7205 32.5969 85.7559 43.583L85.7812 43.7217L85.7832 43.7266C86.8041 49.1993 87.7642 53.1231 89 56.3135C90.2842 59.6286 91.8043 61.9921 93.7041 64.4219L93.707 64.4277L93.7695 64.5078C95.6137 66.8543 97.562 69.0066 99.1816 70.7832C100.247 71.9519 101.103 72.8907 101.762 73.6562V79.0684L89.9473 88.9062L89.5459 89.2402L89.5908 89.7607L91.6641 113.728C78.039 111.203 48.6839 107.928 1.05762 112.747L1.10156 111.89C8.46306 111.016 13.7835 109.898 18.3984 108.337C23.8571 106.49 28.1206 104.086 33.2383 101.22H33.2402L33.374 101.145L33.3779 101.143C45.1266 94.5427 51.3 83.1757 52.7129 80.7617L53.1025 80.0957L53.0898 80.083C54.4536 77.554 56.0304 73.615 56.957 71.0439L56.9834 71.0703L57.4883 69.5195C58.0176 67.8933 58.5471 64.7682 58.9355 61.791C59.3404 58.6881 59.6738 55.0969 59.6738 52.3369L59.7051 50.3418C59.7438 47.9674 59.7355 44.509 59.0498 40.4443C58.2285 35.5758 56.4584 29.8208 52.8037 23.2969C53.7688 21.6379 54.8058 19.8094 55.7471 18.0361C57.02 15.6381 58.4139 12.8214 59.0156 10.6611L59.125 10.2383C59.4513 8.86613 59.5223 6.8359 59.5459 5.125C59.5571 4.30847 59.5556 3.43227 59.5469 2.52734Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
